export default [
	{
		ageGroup: '3 år',
		productName: 'Minitroll',
		price: 1075,
		id: 2349,
		value: '1',
		startDate: '2021-03-01',
		endDate: '2021-03-05',
		displayLength: '5 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-03-01',
		length: '5 dagar',
		qty: '1',
		pricecode: '',
		poollid: 2349,
		priceWithInsurance: 0,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [{ id: 2048, label: 'Level 1' }],
		image:
			'http://static.r360online.se/klappen/images/50fac49b777f4a6e33ae925af6e98783_org.jpg',
		periodOfValidity: '',
		groupName: 'Grupp 2',
		startTime: '11:00',
		endTime: '12:15',
		isPackage: false,
		insurance: false,
		comment: ''
	},
	{
		ageGroup: '9-11 år',
		productName: 'Kidz',
		price: 995,
		id: 2384,
		value: '1',
		startDate: '2021-03-01',
		endDate: '2021-03-04',
		displayLength: '4 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-03-01',
		length: '4 dagar',
		qty: '1',
		pricecode: '',
		poollid: 2384,
		priceWithInsurance: 0,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [{ id: 2048, label: 'Level 1' }],
		image:
			'http://static.r360online.se/klappen/images/02a3fe059fbde2609b8f13d90372bcc5_org.jpg',
		periodOfValidity: '',
		groupName: 'Grupp 1',
		startTime: '09:30',
		endTime: '10:45',
		isPackage: false,
		insurance: false,
		comment: ''
	},
	{
		ageGroup: '9-14 år',
		productName: 'Parkkurs skidupplevelse',
		price: 300,
		id: 2404,
		value: '1',
		startDate: '2021-03-02',
		endDate: '2021-03-02',
		displayLength: '1 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-03-02',
		length: '1 dagar',
		qty: '1',
		pricecode: '',
		poollid: 2404,
		priceWithInsurance: 0,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [{ id: 2063, label: 'Park' }],
		image:
			'http://static.r360online.se/klappen/images/98efc674b1514bcbc8236456c82eb6f8_org.jpg',
		periodOfValidity: '',
		groupName: 'Grupp 1',
		startTime: '13:15',
		endTime: '14:30',
		isPackage: false,
		insurance: false,
		comment: ''
	}
]
